var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "file-preview",
      class: {
        "file-preview--fw": _vm.fullWidth,
      },
      attrs: { "data-type": _vm.type },
    },
    [
      _c(
        "div",
        { staticClass: "file-preview-img" },
        [
          _vm.type === "image"
            ? _c("img", {
                attrs: { src: _vm.url },
                on: {
                  click: function ($event) {
                    return _vm.$emit("click")
                  },
                },
              })
            : _vm._e(),
          _vm.type === "video"
            ? [
                _vm.showVideo
                  ? _c("video", { attrs: { controls: "", src: _vm.url } })
                  : _c(
                      "svg",
                      {
                        attrs: {
                          width: "32",
                          height: "32",
                          viewBox: "0 0 32 32",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 1 16 1C24.2843 1 31 7.71573 31 16Z",
                            stroke: "#8E9CBB",
                            "stroke-width": "2",
                            "stroke-linejoin": "round",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M11 24V8L25 15.7333L11 24Z",
                            stroke: "#8E9CBB",
                            "stroke-width": "2",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
              ]
            : _vm._e(),
          _vm.type === "doc"
            ? _c(
                "svg",
                {
                  staticClass: "file-preview-img__icon",
                  attrs: {
                    width: "33",
                    height: "33",
                    viewBox: "0 0 33 33",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M26.8035 8.296L24.3795 25H17.9475L16.4595 13L14.8035 25H8.5155L6.1875 8.296H11.1315L12.1875 21.424L13.9635 8.296H19.1235L20.6115 21.424L22.0515 8.296H26.8035Z",
                      fill: "#2B579A",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                      stroke: "#2B579A",
                      "stroke-width": "3",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.type === "pdf"
            ? _c(
                "svg",
                {
                  staticClass: "file-preview-img__icon",
                  attrs: {
                    width: "33",
                    height: "33",
                    viewBox: "0 0 33 33",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M1.5 31.5V1.5H31.5V31.5H1.5Z",
                      stroke: "#E30000",
                      "stroke-width": "3",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M18.4486 14.7397C17.205 15.7354 17.1654 15.7596 16.431 16.3868C15.6967 17.014 15.4226 17.1035 14.1731 18.0923M18.4486 14.7397C22.6951 13.107 23.8297 9.49956 20.8864 8.43992C17.943 7.38027 16.3731 10.9298 18.4486 14.7397ZM18.4486 14.7397C18.7117 16.2779 18.7225 16.2654 18.8943 17.2736C19.0695 18.3012 19.0607 18.4132 19.3329 19.95M14.1731 18.0923C15.6889 18.6333 16.7871 19.0334 16.7871 19.0334C16.7871 19.0334 17.8203 19.4006 19.3329 19.95M14.1731 18.0923C10.584 15.3615 6.77769 16.2174 7.29796 19.2059C7.81822 22.1944 11.7902 21.731 14.1731 18.0923ZM19.3329 19.95C23.8993 20.1552 26.1933 23.2073 23.7703 25.1362C21.3472 27.065 18.6614 24.2047 19.3329 19.95Z",
                      stroke: "#E30000",
                      "stroke-width": "2",
                    },
                  }),
                ]
              )
            : _vm._e(),
          _vm.showActions
            ? [
                _vm.type === "image" || _vm.type === "video"
                  ? [
                      _vm.loadImages || _vm.preview
                        ? _c(
                            "div",
                            {
                              staticClass: "file-preview__overlay",
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("click")
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "file-preview__icons" },
                                [
                                  _vm.loadImages
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "file-preview__icon",
                                          attrs: {
                                            href: _vm.url,
                                            download: "",
                                          },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              name: "upload-light",
                                              color: "white",
                                              size: 24,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.preview
                                    ? _c(
                                        "span",
                                        { staticClass: "file-preview__icon" },
                                        [
                                          _vm.type === "image" ||
                                          (_vm.type === "video" &&
                                            !_vm.showVideo)
                                            ? _c("svg-icon", {
                                                attrs: {
                                                  name: "eye",
                                                  size: 32,
                                                  color: "white",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [
                      _vm.loadFiles
                        ? _c(
                            "a",
                            {
                              staticClass: "file-preview__overlay",
                              attrs: { href: _vm.url, download: "" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "file-preview__icons" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "file-preview__icon" },
                                    [
                                      _c("svg-icon", {
                                        attrs: {
                                          name: "upload-light",
                                          color: "white",
                                          size: 24,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm.fileName
        ? _c("div", { staticClass: "file-preview__name" }, [
            _vm._v(" " + _vm._s(_vm.fileName) + " "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }